var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M17.298 1.116C16.648.323 15.45 0 13.158 0H4.842C2.498 0 1.278.344.632 1.188 0 2.011 0 3.223 0 4.901v3.198C0 11.349.749 13 4.842 13h8.316c1.987 0 3.088-.285 3.8-.985C17.688 11.298 18 10.127 18 8.1V4.901c0-1.77-.049-2.989-.702-3.785m-5.742 5.826L7.78 8.967a.57.57 0 0 1-.57-.018.6.6 0 0 1-.28-.51V4.4a.6.6 0 0 1 .28-.51.57.57 0 0 1 .568-.019l3.777 2.013a.6.6 0 0 1 .313.528.6.6 0 0 1-.312.529Z"
})));
export default SvgYoutube;